// extracted by mini-css-extract-plugin
export default {"branding":"styles__branding___3EWIm","brandingImg":"styles__brandingImg___fp7fj"};